import React from 'react';
import { colorTextStatusError } from '@cloudscape-design/design-tokens';

/** Clip-rect style that hides content visually while keeping it in the a11y tree. */
export const visuallyHidden: React.CSSProperties = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  overflow: 'hidden',
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  whiteSpace: 'nowrap',
};

/** Renders text that only screen readers perceive. Optional role for live regions. */
export const ScreenReaderOnly: React.FC<
  React.PropsWithChildren<{ role?: string }>
> = ({ role, children }) => (
  <span role={role} style={visuallyHidden}>
    {children}
  </span>
);

/**
 * Required-field indicator, always rendered inside a Cloudscape FormField `label`.
 * The glyph is decorative (aria-hidden, colour must not be the only cue); the SR-only
 * "(required)" text lives in the label, which FormField associates with the control
 * via aria-labelledby, so a screen reader announces it as part of the field's name.
 * Controls that support it also set ariaRequired for the native state.
 */
const RequiredAsterisk: React.FC = () => (
  <>
    <span aria-hidden="true" style={{ color: colorTextStatusError }}>
      *
    </span>
    <ScreenReaderOnly>(required)</ScreenReaderOnly>
  </>
);

export default RequiredAsterisk;
